import React from 'react'
import { CardVerificationsList } from './list/page'

export const CardVerificationPage = (): JSX.Element => {
  return <CardVerificationsList></CardVerificationsList>
}
